import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

/**
 * Список моделей для выбора (пакет 3 переезда AI на OpenRouter, docs/backlog/ai-openrouter-plan.md).
 * Сервер отдаёт только модели, которые сейчас есть в каталоге OpenRouter, и умолчания кампании.
 */
export interface AiModelOption {
  id: string;
  label: string;
  note: string;
  price?: string;
  isDefault: boolean;
}

export interface AiModelsResponse {
  assistant: AiModelOption[];
  illustration: AiModelOption[];
  map: AiModelOption[];
  campaignDefaults: { assistant: string; illustration: string; map: string };
}

const EMPTY: AiModelsResponse = {
  assistant: [], illustration: [], map: [],
  campaignDefaults: { assistant: '', illustration: '', map: '' },
};

const cache = new Map<string, Promise<AiModelsResponse>>();

/** Сбросить кэш — после смены умолчаний кампании в настройках. */
export function invalidateAiModels(sessionId?: string): void {
  if (sessionId) cache.delete(sessionId); else cache.clear();
}

export function useAiModels(sessionId: string | undefined): AiModelsResponse & { loaded: boolean } {
  const [data, setData] = useState<AiModelsResponse>(EMPTY);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!sessionId) return;
    let alive = true;
    let p = cache.get(sessionId);
    if (!p) {
      p = apiFetch(`/api/sessions/${sessionId}/ai/models`)
        .then(r => (r.ok ? r.json() as Promise<AiModelsResponse> : EMPTY))
        .catch(() => EMPTY);
      cache.set(sessionId, p);
    }
    p.then(d => { if (alive) { setData(d); setLoaded(true); } });
    return () => { alive = false; };
  }, [sessionId]);
  return { ...data, loaded };
}
